// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as filters from './utils/filters'
import { share } from './utils/share'
// babel-polyfill
// import 'babel-polyfill'

// css
import '@/assets/css/common.css'

// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

// import vOutsideEvents from 'vue-outside-events'
// Vue.use(vOutsideEvents)

Vue.config.productionTip = false

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 后台管理增加权限，目前是admin目录下的都需要权限，没有在路由里配置
router.beforeEach((to, from, next) => {
  let userInfo =
    (localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo'))) ||
    {}
  let token = localStorage.getItem('token')
  if (!token && to.path.indexOf('admin') !== -1) {
    next('/')
  } else if (!userInfo.artIdentify && to.path.indexOf('admin') !== -1) {
    next({ path: '/artIdentify' })
  } else {
    next()
  }
})

// dcument title
router.afterEach(to => {
  let title = ''
  if (to.meta && to.meta.title) {
    title = `${to.meta.title}-`
  }
  document.title = `${title}在艺-爱艺术的人都在这里`
})

new Vue({
  router,
  render: h => h(App),
  created() {
    // 移动端跳转
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.$router.replace('mobile')
    }
  }
}).$mount('#app')

share({
  title: '在艺App',
  desc: '爱艺术的人都在这里',
  link: process.env.VUE_APP_LOCATION_URL,
  imgUrl: 'https://img.zai-art.com/logo/512.png',
  imgWidth: '512',
  imgHeight: '512'
})
